// DS2 — 1px line(#EEF0F3) 구분선. bleed = 칼럼 밖 화면 전폭(가로 스크롤 0).
// ds4 A: space="sec" = 섹션 사이 전폭 구분 띠(10 · ≤760 8 #EEF1F5 + 위아래 1px #E3E7ED, 위아래 섹션 여백 32 · 모바일 24) · sep = 여백 없는 띠만.
import './ds2.css';

export interface DividerProps {
  bleed?: boolean;
  space?: 'none' | 'sec';
  /** ds4 — 여백 없는 전폭 구분 띠. */
  sep?: boolean;
  className?: string;
}

export default function Divider({ bleed, space = 'none', sep, className }: DividerProps) {
  const attrs: Record<string, string> = {};
  if (bleed) attrs['data-bleed'] = '';
  if (space === 'sec') attrs['data-space'] = 'sec';
  if (sep) attrs['data-sep'] = '';
  return <hr className={className ? `ds2-div ${className}` : 'ds2-div'} data-ds2="divider" {...attrs} />;
}
